import styled, { css } from "styled-components";
import { Link as RouterLink } from "react-router-dom";
import colors from "styles/colors";

const Flex = styled.div`
  display: flex;
`;

const CenterFlex = styled(Flex)`
  justify-content: center;
  align-items: center;
`;

const Row = styled(Flex)`
  flex-direction: row;
  align-items: center;
`;

const RowSpaceBetween = styled(Row)`
  justify-content: space-between;
`;

const RowFlexStart = styled(Row)`
  justify-content: flex-start;
`;

const FitWidth = styled.div`
  width: 100%;
`;

const Container = styled.div`
  padding: 1em;
`;

const Title = styled.h3`
  margin-top: 0;
`;

const SubTitle = styled.text`
  font-style: italic;
`;

const Links = styled(RouterLink)`
  && {
    text-decoration: none;
    font-size: 14px;
    font-weight: ${({ $isActive }) => ($isActive ? 500 : 400)};
    line-height: 24px;
    letter-spacing: -0.04px;
    display: inline-flex;
    align-items: center;
    padding: 8px 12px;
    border-radius: 6px;
    background-color: ${({ $isActive }) => ($isActive ? "#eaeff1" : "transparent")};
    color: #3C535C;
    &:hover {
      cursor: pointer;
      background-color: ${({ $isActive }) => ($isActive ? "#eaeff1" : "rgba(9, 119, 158, 0.07)")};
      color: #01151D;
    }
  }
`;

const UiLink = styled.div`
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: ${colors.coreColors.jllRed.accent};
  }
`;

const HyperlinkCell = styled(RouterLink)`
  && {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-decoration: underline;
    text-decoration-color: #DFE5E8;
    text-underline-offset: 2px;
    color: #09779E;
    cursor: pointer;
    &:hover {
      color: #09779E;
    }
  }
`;

const disabledCSS = styled(css)`
  opacity: 0.5;
  pointer-events: none;
  cursor: none;
`;

const notClickableCSS = styled(css)`
  pointer-events: none;
  cursor: inherit;
`;

export {
  Flex,
  CenterFlex,
  Row,
  RowFlexStart,
  RowSpaceBetween,
  FitWidth,
  Container,
  Title,
  SubTitle,
  Links,
  UiLink,
  HyperlinkCell,
  disabledCSS,
  notClickableCSS,
};
